import { booleanAttribute, ChangeDetectionStrategy, Component, input } from '@angular/core';
import { cueQrCode, IconComponent } from '@cue/ui/icons';
import { ImageComponent } from '@cue/images';
import { LocalizedStringPipe } from '@cue/utilities';
import { LocalizedString } from '@cue/api';
import { NgClass } from '@angular/common';

export type POI = {
  qrCodeId?: string;
  file?: string;
  name: LocalizedString;
};

@Component({
  selector: 'cue-poi',
  imports: [IconComponent, ImageComponent, LocalizedStringPipe, NgClass],
  templateUrl: './poi.component.html',
  styleUrl: './poi.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PoiComponent {
  ICONS = {
    cueQrCode,
  };

  link = input<boolean, boolean | string>(true, {
    transform: booleanAttribute,
  });
  poi = input.required<POI>();
  selected = input<boolean, boolean | string>(false, {
    transform: booleanAttribute,
  });
}
